import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import AuthLayout from 'components/auth/AuthLayout'
import Layout from '../layout/Layout'
import MasterDataLayout from 'components/masterdata/MasterDataLayout'
import EmployeeLayout from 'components/employee/EmployeeLayout'
import DelinquencyLayout from 'components/delinquency/DelinquencyLayout'
import SubAdmin from 'components/subAdmin/SubAdminLayout'
import NotFound from 'components/auth/NotFound'
import ViewDelinquency from 'components/delinquency/ViewDelinquency'
import Dashboard from 'components/dashboard/Dashboard'
import AdminDashboard from 'components/dashboard/AdminDashboard'
import AdminUnit from 'components/dashboard/AdminUnitDelinquency'
import AdminDeliquency from 'components/dashboard/AdminEmployeeDeliquency'
import Transfer from 'components/transfer/Transfer'
import Report from 'components/report/Report'

function DashboardRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute
            roles={['SUPERADMIN', 'ADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
          >
            <Layout />
          </PrivateRoute>
        }
      >
        <Route
          path="masterdata"
          element={
            <PrivateRoute roles={['ADMIN', 'SUPERADMIN']}>
              <MasterDataLayout />
            </PrivateRoute>
          }
        />
        <Route
          path="subadmin"
          element={
            <PrivateRoute roles={['ADMIN', 'SUPERADMIN']}>
              <SubAdmin />
            </PrivateRoute>
          }
        />

        <Route
          path="employee"
          element={
            <PrivateRoute roles={['UNITADMIN', 'SUBUNITADMIN']}>
              <EmployeeLayout />
            </PrivateRoute>
          }
        />

        <Route
          path="delinquency"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <DelinquencyLayout />
            </PrivateRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <Dashboard />
            </PrivateRoute>
          }
        />
           <Route
          path="admindashboard"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="view-delinquency"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <ViewDelinquency />
            </PrivateRoute>
          }
        />

        <Route
          path="admin-unit"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <AdminUnit />
            </PrivateRoute>
          }
        />
          <Route
          path="admin-deliquency"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <AdminDeliquency />
            </PrivateRoute>
          }
        />
           <Route
          path="transfer"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN', 'SUBUNITADMIN']}
            >
              <Transfer />
            </PrivateRoute>
          }
        />

          <Route
          path="report"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN', 'UNITADMIN' ]}
            >
              <Report />
            </PrivateRoute>
          }
        />
        <Route
          path="Employe_Report"
          element={
            <PrivateRoute
              roles={['ADMIN', 'SUPERADMIN']}
            >
              <Report />
            </PrivateRoute>
          }
        />
      



        

        


        

        <Route path="change-password" element={<AuthLayout />} />


        
        

        {/* <Route path="delinquency" element={<DelinquencyLayout />} /> */}

        <Route index element={<AuthLayout />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default DashboardRoutes
